import React from "react";
import {css, Theme} from "@emotion/react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, mt, pv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useInvestmentOfferCities} from "../hooks/use_investment_offer_cities";
import {InvestmentOfferTile} from "./InvestmentOfferTile";

export const InvestmentOfferCities = () => {
    const investmentOfferCities = useInvestmentOfferCities();

    return (
        <Container as="section" css={investmentOfferCitiesContainer} fluid>
            <Container>
                <Text align="center" css={mb(5)} as="h2" variant="headline_3">
                    Zobacz najlepsze oferty pod inwestycje w wybranym mieście
                </Text>

                <Row>
                    <Col>
                        <div css={citiesList}>
                            {investmentOfferCities.map((investmentOfferCity) => {
                                return <InvestmentOfferTile key={investmentOfferCity.title} ratioVariant="horizontal" {...investmentOfferCity} />;
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

const investmentOfferCitiesContainer = (theme: Theme) => css`
    ${mt(8)};
    ${pv(5)};
    background-color: ${theme.colors.background[200]};
`;

const citiesList = (theme: Theme) => css`
    display: grid;
    grid-template-columns: repeat(1, 336px);
    gap: 2.4rem;
    justify-content: center;

    @media (min-width: ${theme.breakpoints.md}) {
        grid-template-columns: repeat(3, 360px);
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, mt, pv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useInvestmentOfferCities} from "../hooks/use_investment_offer_cities";
import {InvestmentOfferTile} from "./InvestmentOfferTile";

export const InvestmentOfferCities = () => {
    const investmentOfferCities = useInvestmentOfferCities();

    return (
        <Container as="section" css={investmentOfferCitiesContainer} fluid>
            <Container>
                <Text align="center" css={mb(5)} as="h2" variant="headline_3">
                    Zobacz najlepsze oferty pod inwestycje w wybranym mieście
                </Text>

                <Row>
                    <Col>
                        <div css={citiesList}>
                            {investmentOfferCities.map((investmentOfferCity) => {
                                return <InvestmentOfferTile key={investmentOfferCity.title} ratioVariant="horizontal" {...investmentOfferCity} />;
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

const investmentOfferCitiesContainer = (theme: Theme) => css`
    ${mt(8)};
    ${pv(5)};
    background-color: ${theme.colors.background[200]};
`;

const citiesList = (theme: Theme) => css`
    display: grid;
    grid-template-columns: repeat(1, 336px);
    gap: 2.4rem;
    justify-content: center;

    @media (min-width: ${theme.breakpoints.md}) {
        grid-template-columns: repeat(3, 360px);
    }
`;
